import React from 'react';
import { Box, Grid, Paper, Stack, Typography } from '@mui/material';
import Section from '../shared/Section';
import SectionHeading from '../shared/SectionHeading';
const Veggie = '/assets/images/DK7.jpg';

const workflowSteps = [
  {
    title: 'Digitise demand signals',
    description:
      'Connect HR data, hybrid schedules, and dietary profiles to forecast attendance so production starts with an accurate headcount.',
  },
  {
    title: 'Automate portion prep',
    description:
      'Smart batching guides kitchens on exact prep volumes and flags ingredient risk, keeping surplus out of the walk-in and on the menu.',
  },
  {
    title: 'Close the recovery loop',
    description:
      'Feedback, sensors, and donation partners plug into FoodFe OS so adjustments and redistribution happen before leftovers become waste.',
  },
];

const workflowDescription =
  'From planning to plate, our zero-waste engine guides every team on what to prep, when to deliver, and how to improve with each service.';

export const ButHow = () => {
  return (
    <Section id='ButHow' background='#FFFFFF'>
      <Grid container spacing={{ xs: 6, md: 10 }} alignItems='center'>
        <Grid item xs={12} md={6}>
          <Stack spacing={5}>
            <SectionHeading
              align='left'
              eyebrow='How it works'
              title='How our zero-waste engine runs'
              description={workflowDescription}
            />
            <Stack spacing={3}>
              {workflowSteps.map((step, index) => (
                <Paper
                  key={step.title}
                  elevation={0}
                  sx={{
                    p: { xs: 3, md: 4 },
                    borderRadius: 24,
                    border: '1px solid',
                    borderColor: 'divider',
                    backgroundColor: 'background.paper',
                    maxWidth: { xs: '100%', md: 560 },
                    mx: { xs: 'auto', md: 0 },
                    boxShadow:
                      '0px 18px 36px rgba(31, 36, 51, 0.08), 0px 10px 24px rgba(31, 36, 51, 0.04)',
                    transition: 'transform 200ms ease, box-shadow 220ms ease, border-color 200ms ease',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                      boxShadow: '0px 28px 50px rgba(31, 36, 51, 0.16)',
                      borderColor: 'primary.main',
                    },
                    '&:hover .step-index': {
                      transform: 'scale(1.08)',
                      background: 'linear-gradient(135deg, #4A5AA2 0%, #2F3A72 100%)',
                      boxShadow: '0px 12px 20px rgba(47, 58, 114, 0.25)',
                    },
                  }}
                >
                  <Stack
                    direction='row'
                    spacing={3}
                    alignItems='center'
                  >
                    <Box
                      className='step-index'
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: '50%',
                        background: 'linear-gradient(135deg, #2F3A72 0%, #252E55 100%)',
                        flexShrink: 0,
                        display: 'grid',
                        placeItems: 'center',
                        color: '#FFFFFF',
                        fontWeight: 600,
                        fontSize: '1.6rem',
                        transition: 'transform 160ms ease, box-shadow 200ms ease, background 200ms ease',
                      }}
                    >
                      {index + 1}
                    </Box>
                    <Stack spacing={1.5}>
                      <Typography variant='h4'>{step.title}</Typography>
                      <Typography variant='body1'>{step.description}</Typography>
                    </Stack>
                  </Stack>
                </Paper>
              ))}
            </Stack>
          </Stack>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              position: 'relative',
              width: 'min(520px, 100%)',
              mx: 'auto',
              borderRadius: 32,
              overflow: 'hidden',
              p: { xs: 2, md: 2.5 },
              background: 'linear-gradient(135deg, rgba(47,58,114,0.08) 0%, rgba(246,120,95,0.14) 100%)',
              boxShadow: '0px 30px 60px rgba(31, 36, 51, 0.18)',
            }}
          >
            <Box
              component='img'
              src={Veggie}
              alt='Chef preparing fresh vegetables'
              sx={{
                width: '100%',
                height: { xs: 260, sm: 320, md: 360 },
                objectFit: 'cover',
                display: 'block',
                borderRadius: 24,
                boxShadow: '0px 18px 38px rgba(31, 36, 51, 0.16)',
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                inset: 0,
                borderRadius: 'inherit',
                border: '1px solid rgba(255, 255, 255, 0.35)',
                pointerEvents: 'none',
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Section>
  );
};
